import { useEffect, useState } from 'react';
import staatliches from '../../assets/fonts/staatliches/regular.ttf';
import InterRegularWoff2 from '../../assets/fonts/Inter/Inter-Regular.woff2'
import InterRegularWoff from '../../assets/fonts/Inter/Inter-Regular.woff'
import InterRegularTtf from '../../assets/fonts/Inter/Inter-Regular.ttf'
import InterMediumWoff2 from '../../assets/fonts/Inter/Inter-Medium.woff2'
import InterMediumWoff from '../../assets/fonts/Inter/Inter-Medium.woff'
import InterMediumTtf from '../../assets/fonts/Inter/Inter-Medium.ttf'
import InterSemiBoldWoff2 from '../../assets/fonts/Inter/Inter-SemiBold.woff2'
import InterSemiBoldWoff from '../../assets/fonts/Inter/Inter-SemiBold.woff'
import InterSemiBoldTtf from '../../assets/fonts/Inter/Inter-SemiBold.ttf'
import InterBoldWoff2 from '../../assets/fonts/Inter/Inter-Bold.woff2'
import InterBoldWoff from '../../assets/fonts/Inter/Inter-Bold.woff'
import InterBoldTtf from '../../assets/fonts/Inter/Inter-Bold.ttf'
import InterExtraBoldWoff2 from '../../assets/fonts/Inter/Inter-ExtraBold.woff2'
import InterExtraBoldWoff from '../../assets/fonts/Inter/Inter-ExtraBold.woff'
import InterExtraBoldTtf from '../../assets/fonts/Inter/Inter-ExtraBold.ttf'

const useFontsPreloader = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    try {
      const staatlichesReg = new FontFace('Staatliches', `url(${staatliches})`, { weight: 400 });

      const interReg = new FontFace('Inter', `url(${InterRegularWoff}), url(${InterRegularWoff2}) , url(${InterRegularTtf}) `, { weight: 400 });
      const interMed = new FontFace('Inter', `url(${InterMediumWoff}), url(${InterMediumWoff2}) , url(${InterMediumTtf}) `, { weight: 500 });
      const interSem = new FontFace('Inter', `url(${InterSemiBoldWoff}), url(${InterSemiBoldWoff2}), url(${InterSemiBoldTtf})`, { weight: 600 });
      const interBold = new FontFace('Inter', `url(${InterBoldWoff}), url(${InterBoldWoff2}), url(${InterBoldTtf})`, { weight: 700 });
      const interExtBold = new FontFace('Inter', `url(${InterExtraBoldWoff}), url(${InterExtraBoldWoff2}), url(${InterExtraBoldTtf})`, { weight: 800 });

      const fonts = [staatlichesReg, interReg, interMed, interSem, interBold, interExtBold];

      fonts.forEach(font => {
        document.fonts.add(font);
        font.load();
      });
      document.fonts.ready.then(() => {
        setLoaded(true);
      });
    } catch (e) {
      console.error(e);
      setLoaded(true);
    }
  }, []);

  return loaded;
};

export {
  useFontsPreloader,
}
